import styled from "styled-components";

export const StyledLine = styled.div`
    width: 100%;
    border: 1px solid ${(props) => props.theme.grayscale[50]};
`;
